module.exports = __webpack_public_path__ + "img/medical_top.eed961fe.jpg";